// @ts-nocheck
import React from "react"
import { Buttons } from "../../../../../composed-components"
import { Flex } from "../../../../../container-components"
import { Popovers } from "../../../../../element-components"
import { Typography } from "../../../../../typo-components"
import { axiosWrapper } from "../../../../axios_old"
import { formatDate } from "../../../../formating"
import { normalizeString } from "../../../../functions"

class StripeSubscription {
  constructor(attributes) {
    Object.assign(this, attributes)
  }

  get payment() {
    return {
      ...(this.paymentMethod || {}),
      date: this.paymentMethod
        ? new Date(this.paymentMethod.expYear, this.paymentMethod.expMonth - 1)
        : new Date(null),
      toString: () =>
        normalizeString({
          data: this.paymentMethod?.brand,
          actions: ["capitalize"],
        }),
    }
  }

  get addedDate() {
    return this.createdTs
  }

  Wallet() {
    return (
      <Typography margin="0 0 0 0" color="primary" variant="t6">
        {this.paymentMethod ? (
          <>
            {" *"}
            {this.payment.last4 || ""}
            (exp{" "}
            {formatDate({
              data: this.payment.date,
              actions: ["expiration"],
            })}
            )
          </>
        ) : (
          "None"
        )}
      </Typography>
    )
  }

  Update({ handleClick }) {
    return (
      <Flex nowrap row>
        <Buttons.FormDeleteButton
          isInline
          iconSize="small"
          text="Update this payment method?"
          onClick={handleClick}
          color="primary"
          iconConfig={{ name: "edit" }}
        />
      </Flex>
    )
  }

  get formInputs() {
    return [
      { name: "amount", type: "dec", label: "Amount", input: "number" },
      { name: "description", label: "Description" },
    ]
  }
}

export const EMPLOYER_SUBSCRIPTION_STATUS = {
  ACTIVE: "active",
  TERMINATED: "ended",
  PENDING_TERMINATION: "will end",
}

class ADPSubscription {
  constructor(attributes) {
    Object.assign(this, attributes)
  }

  Wallet() {
    return (
      <Typography margin="0 0 0 0" color="primary" variant="t6">
        ADP Metered Billing
      </Typography>
    )
  }

  Update() {
    return (
      <Flex nowrap row>
        <Popovers.Icon
          iconConfig={{
            name: "info",
            size: "small",
            style: { paddingLeft: "7px", marginRight: "20px" },
          }}
          popoverConfig={{
            jsx: (
              <Flex column>
                <Typography variant="t7">N/A</Typography>
              </Flex>
            ),
          }}
        />
      </Flex>
    )
  }

  get formInputs() {
    return [
      {
        name: "amount",
        type: "dec",
        label: "Amount Per Person",
        input: "number",
      },
      {
        name: "quantity",
        type: "integer",
        label: "Quantity",
        input: "number",
        required: { type: "number" },
      },
      { name: "description", label: "Description" },
    ]
  }
}

class EmployerSubscription {
  static async getOne(token, employerId) {
    const {
      data: { data: subscriptionData },
    } = await axiosWrapper(
      "GET",
      `employer/${employerId}/billing/v2/subscription?include`,
      null,
      null,
      token
    )

    const sub = subscriptionData?.find((s) => s.type === "STRIPE") || { id: true }
    return new EmployerSubscription(sub)
  }

  constructor(attributes) {
    Object.assign(this, attributes)
    this.provider = new StripeSubscription(attributes.stripeSubscription)
  }

  provider
}

export { StripeSubscription, ADPSubscription }
export default EmployerSubscription
